export const SET_DOCUMENTATION_LOADING = "SET_DOCUMENTATION_LOADING";
export const RESET_DOCUMENTATION_VARS = "RESET_DOCUMENTATION_VARS";

export const GET_ALL_DOCUMENTATIONS = "GET_ALL_DOCUMENTATIONS";
export const GET_ALL_DOCUMENTATIONS_SUCCESS = "GET_ALL_DOCUMENTATIONS_SUCCESS";
export const GET_ALL_DOCUMENTATIONS_FAILURE = "GET_ALL_DOCUMENTATIONS_FAILURE";

export const GET_DOCUMENT_BY_ID = "GET_DOCUMENT_BY_ID";
export const GET_DOCUMENT_BY_ID_SUCCESS = "GET_DOCUMENT_BY_ID_SUCCESS";
export const GET_DOCUMENT_BY_ID_FAILURE = "GET_DOCUMENT_BY_ID_FAILURE";

export const CREATE_DOCUMENT = "CREATE_DOCUMENT";
export const CREATE_DOCUMENT_SUCCESS = "CREATE_DOCUMENT_SUCCESS";
export const CREATE_DOCUMENT_FAILURE = "CREATE_DOCUMENT_FAILURE";

export const UPDATE_DOCUMENT_BY_ID = "UPDATE_DOCUMENT_BY_ID";
export const UPDATE_DOCUMENT_BY_ID_SUCCESS = "UPDATE_DOCUMENT_BY_ID_SUCCESS";
export const UPDATE_DOCUMENT_BY_ID_FAILURE = "UPDATE_DOCUMENT_BY_ID_FAILURE";

export const DELETE_DOCUMENT_BY_ID = "DELETE_DOCUMENT_BY_ID";
export const DELETE_DOCUMENT_BY_ID_SUCCESS = "DELETE_DOCUMENT_BY_ID_SUCCESS";
export const DELETE_DOCUMENT_BY_ID_FAILURE = "DELETE_DOCUMENT_BY_ID_FAILURE";

export const EXPORT_DOCUMENTS = "EXPORT_DOCUMENTS";
export const EXPORT_DOCUMENTS_SUCCESS = "EXPORT_DOCUMENTS_SUCCESS";
export const EXPORT_DOCUMENTS_FAILURE = "EXPORT_DOCUMENTS_FAILURE";

export const IMPORT_DOCUMENTS = "IMPORT_DOCUMENTS";
export const IMPORT_DOCUMENTS_SUCCESS = "IMPORT_DOCUMENTS_SUCCESS";
export const IMPORT_DOCUMENTS_FAILURE = "IMPORT_DOCUMENTS_FAILURE";
